const BASE_PATH = '/onboarding/business';

export const BUSINESS_ONBOARDING_ROUTES = {
  SIGN_UP: BASE_PATH + '/signup',
  YOUR_NAME: BASE_PATH + '/your-name',
  PRODUCTS: BASE_PATH + '/products',
  START_TRIAL: BASE_PATH + '/start-trial',
  SETUP_WORKSPACE: BASE_PATH + '/setup-workspace',
};

/** Minimum card quantity for business subscription */
export const FALLBACK_MIN_UNIT_QUANTITY = 3;

/** Maximum card quantity for business subscription */
export const MAX_UNIT_QUANTITY = 20000;
